import { Button } from '../../../components/ui/button';
import { findContactsSkipLabel } from './findContactsCopy';
import { MoveToBrandProgress } from './MoveToBrandProgress';
import { OperationProgress } from './OperationProgress';
import { retryFailureCopy, retrySkipCopy } from './retryLabels';
import type { FindContactsFlow } from './useFindContactsFlow';
import type { OutreachRetry } from './useOutreachRetry';

interface OutreachOperationPanelsProps {
  campaignId: string;
  removeOperationId: string | null;
  onRemoveDone: () => void;
  onRemoveError: () => void;
  findContacts: FindContactsFlow;
  retry: OutreachRetry;
  moveOperationId: string | null;
  onMoveSettled: () => void;
}

/** The inbox's durable batches — bulk remove, move to brand, find contacts, retry — each with its own progress. */
export function OutreachOperationPanels({ campaignId, removeOperationId, onRemoveDone, onRemoveError, findContacts, retry, moveOperationId, onMoveSettled }: OutreachOperationPanelsProps) {
  return (
    <>
      {removeOperationId && (
        <div className="rounded-xl border border-border bg-card p-4">
          <OperationProgress campaignId={campaignId} operationId={removeOperationId} onDone={onRemoveDone} onError={onRemoveError} />
        </div>
      )}
      {moveOperationId && <MoveToBrandProgress campaignId={campaignId} operationId={moveOperationId} onSettled={onMoveSettled} />}
      {findContacts.operationId && (
        <div className="rounded-xl border border-border bg-card p-4">
          <OperationProgress
            campaignId={campaignId}
            operationId={findContacts.operationId}
            outcomeCopy={findContactsSkipLabel}
            onDone={findContacts.onDone}
            onError={findContacts.onError}
          />
        </div>
      )}
      {retry.operationId && (
        <div className="flex items-start gap-3 rounded-xl border border-border bg-card p-4">
          <div className="min-w-0 flex-1">
            <OperationProgress
              key={retry.operationId}
              campaignId={campaignId}
              operationId={retry.operationId}
              outcomeCopy={retrySkipCopy}
              failureCopy={retryFailureCopy}
              onDone={retry.onDone}
              onError={retry.onError}
            />
          </div>
          {retry.hasFailures ? (
            <Button size="sm" variant="ghost" onClick={retry.dismiss}>
              Dismiss
            </Button>
          ) : null}
        </div>
      )}
    </>
  );
}
